/**
 * HeaderInfoTip — the ⓘ after a section, column, page or drawer title, explaining what
 * it shows.
 *
 * A thin wrapper on InfoPopover (docs/DUPLICATION_AUDIT.md, B18 and B31). It replaces
 * local copies that opened on hover only, so the explanation could not be reached on a
 * tablet; InfoPopover also pins open on a click or tap, works from the keyboard and
 * closes on Escape.
 *
 * @param {string} title — the popover's heading ("About This Chart")
 * @param {node} [body]
 * @param {{ heading?: string, body: node }[]} [sections] — further headed paragraphs
 *        (EHR Tasks, Add Campus); `body` may be left out when every paragraph is one
 * @param {boolean} [spaced] — 8px after the title instead of 6px (page and drawer
 *        titles, as their copies drew it)
 * @param {number} [maxWidth]
 * @param {string} [label] — the ⓘ's accessible name; defaults to `title`
 */

import InfoPopover from './InfoPopover.jsx';
import './header-info-tip.css';

const HeaderInfoTip = ({ title, body, sections, spaced = false, maxWidth, label }) => (
    <InfoPopover
        heading={title}
        body={body}
        sections={sections}
        maxWidth={maxWidth}
        label={label}
        triggerClassName={`header-info-tip${spaced ? ' header-info-tip--spaced' : ''}`}
    />
);

export default HeaderInfoTip;
